export const ADMIN_PROFILE_SETTINGS_CHANGE_EMAIL_ROUTE_NAME = Symbol('admin.profile-settings.change-email');
export const AFFILIATE_PROFILE_SETTINGS_CHANGE_EMAIL_ROUTE_NAME = Symbol('affiliate.profile-settings.change-email');

export const ADMIN_PROFILE_SETTINGS_CHANGE_EMAIL_SAVE_URL = 'admin/profile/email_update';
export const AFFILIATE_PROFILE_SETTINGS_CHANGE_EMAIL_SAVE_URL = 'affiliate/settings/email_update';
export const PROFILE_SETTINGS_CHANGE_EMAIL_SAVE_MUTATION_KEY = 'profile-settings.change-email.save';
